module.exports = __webpack_public_path__ + "img/video.a87d26d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/supplies/video.svg
// module id = 1133
// module chunks = 1